import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { ProgramsSection } from "../components/ProgramsSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { EventsSection } from "../components/EventsSection";
import { DonateSection } from "../components/DonateSection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { programs, testimonials, events } from "../data/mockData";

export const Home = () => {

  return (
    <div data-testid="home-page">
      <Header />
      <HeroSection />
      <AboutSection />
      <ProgramsSection programs={programs} />
      <TestimonialsSection testimonials={testimonials} />
      <EventsSection events={events} />
      <DonateSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;